// Configuration Crisp
export const CRISP_CONFIG = {
  // Website ID Crisp configuré
  WEBSITE_ID: import.meta.env.VITE_CRISP_WEBSITE_ID || 'ff52ff8b-1318-407e-a4c4-bdf3cf457685',
  
  // Événements personnalisés pour tracker les interactions
  EVENTS: {
    HELP_CHAT_OPENED: 'help_chat_opened',
    FAQ_EXPANDED: 'faq_expanded',
    ACADEMY_ACCESSED: 'academy_accessed',
    SIGNUP: 'signup',
    LOGIN: 'login'
  }
} as const;

// Types pour les événements
export type CrispEventName = typeof CRISP_CONFIG.EVENTS[keyof typeof CRISP_CONFIG.EVENTS];